import React from "react";
import styles from "./HeaderDesktop.module.scss";
import { ReactComponent as CloseIcon } from "../../../../assets/svg/close.svg";
import Slide from "@material-ui/core/Slide";
import LawyerAvatar from "../../../../assets/img/lawyerAvatar.png";
import PersonRoundedIcon from "@material-ui/icons/PersonRounded";
import classNames from "classnames";

const HeaderDesktop = (props) => (
  <div
    className={classNames({
      [styles.HeaderDesktop]: true,
      [styles.appointment]: props.type == "appointment",
    })}
  >
    {props.boxContentLawyerInfo && (
      <div className={styles.left}>
        {props.imageUrl && (
          <img
            src={props.imageUrl}
            alt={props.subtitle}
            className={styles.avatar}
          />
        )}
        {!props.imageUrl && (
          <div className={styles.noAvatar}>
            <PersonRoundedIcon />
          </div>
        )}
      </div>
    )}
    <div className={styles.right}>
      {props.title && <div className={styles.title}>{props.title}</div>}

      {props.subtitle && (
        <div className={styles.subTitle}>{props.subtitle}</div>
      )}
    </div>

    <div className={styles.topRight}>
      {props.step && (
        <span className={styles.step}>
          {" "}
          {Math.floor(props.step)}/{props.maxStep ? props.maxStep : 3}
        </span>
      )}
      <CloseIcon
        className={styles.close}
        onClick={() => {
          props.setBoxContent(false, props.type);
        }}
      />
    </div>
  </div>
);

HeaderDesktop.defaultProps = {};

export default HeaderDesktop;
